import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    width: 100%;
    background: ${theme.v3.colors.neutral[100]};
    padding: 0 ${theme.v3.spacing.md};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 0 20px;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    background: ${theme.v3.colors.neutral[100]};
    border-radius: ${theme.v3.border.radius.xl};
    padding: ${theme.v3.spacing.xs} ${theme.v3.spacing.md};
    gap: ${theme.v3.spacing.xl};

    @media (max-width: ${theme.v3.breakpoints.md}) {
      padding: 32px 20px;
    }
  `}
`;
